/**
 * 收费处路由
 */
const basePath = 'live-toll'

var liveTollRoutes = [
  {
    path: `${basePath}/registration-list`,
    name: `${basePath}/registration-list`,
    meta: {
      title: '入院登记列表',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/live-toll/registration-list.vue'], resolve)
  },
  {
    path: `${basePath}/patient-create`, // 這個暫時沒用了,加多了
    name: `${basePath}/patient-create`,
    meta: {
      title: '新建病人',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: {
          title: '入院登记列表',
          path: `default/${basePath}/registration-list`
        }
      }
    },
    component: resolve => require(['../views/page/live-toll/patient-create.vue'], resolve)
  },
  {
    path: `${basePath}/patient-register/:id`,
    name: `${basePath}/patient-register`,
    meta: {
      title: '入院住院基本信息登记',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: {
          title: '入院登记列表',
          path: `/default/${basePath}/registration-list`
        }
      }
    },
    component: resolve => require(['../views/page/live-toll/patient-register.vue'], resolve)
  },
  {
    path: `${basePath}/medicare-registration-list`,
    name: `${basePath}/medicare-registration-list`,
    meta: {
      title: '医保入院登记列表',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/live-toll/medicare-registration-list.vue'], resolve)
  },
  {
    path: `${basePath}/medicare-patient-register/:id`,
    name: `${basePath}/medicare-patient-register`,
    meta: {
      title: '入院住院基本信息登记',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: {
          title: '医保入院登记列表',
          path: `/default/${basePath}/medicare-registration-list`
        }
      }
    },
    component: resolve => require(['../views/page/live-toll/medicare-patient-register.vue'], resolve)
  },
  {
    path: `${basePath}/live-patient-list`,
    name: `${basePath}/live-patient-list`,
    meta: {
      title: '住院病人查询',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/live-toll/live-patient-list.vue'], resolve)
  },
  {
    path: `${basePath}/live-patient-detail/:id/:patientId`,
    name: `${basePath}/live-patient-detail`,
    meta: {
      title: '住院病人详情',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: {
          title: '住院病人查询',
          path: `/default/${basePath}/live-patient-list`
        }
      }
    },
    component: resolve => require(['../views/page/live-toll/live-patient-detail.vue'], resolve)
  },
  {
    path: `${basePath}/registration-list-edit/`,
    name: `${basePath}/registration-list-edit`,
    meta: {
      title: '住院病人编辑',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: {
          title: '入院登记列表',
          path: `/default/${basePath}/registration-list`
        }
      }
    },
    component: resolve => require(['../views/page/live-toll/live-patient-edit.vue'], resolve)
  },
  {
    path: `${basePath}/live-patient-edit/`,
    name: `${basePath}/live-patient-edit`,
    meta: {
      title: '住院病人编辑',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: {
          title: '住院病人查询',
          path: `/default/${basePath}/live-patient-list`
        }
      }
    },
    component: resolve => require(['../views/page/live-toll/live-patient-edit.vue'], resolve)
  },
  // 医保的路由
  {
    path: `${basePath}/insurance-registration/`,
    name: `${basePath}/insurance-registration`,
    meta: {
      title: '住院医保登记',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: {
          title: '入院登记列表',
          path: `/default/${basePath}/registration-list`
        }
      }
    },
    // component: resolve => require([insuranceRegistration], resolve)
    component: () => {
      if (process.env.YB_LOCAL === 'jieyang') {
        return import('../views/page/medical-insurance-jieyang/insurance-registration.vue')
      } else {
        return import('../views/page/medical-insurance/insurance-registration.vue')
      }
    }
  },
  {
    path: 'payday-info-list',
    name: 'payday-info-list',
    meta: {
      title: '住院日结',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/live-toll/payday-info-list.vue'], resolve)
  },
  {
    path: 'payday-list',
    name: 'payday-list',
    meta: {
      title: '住院日结查询',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/live-toll/payday-list.vue'], resolve)
  },
  {
    path: 'records-jiesu-list',
    name: 'records-jiesu-list',
    meta: {
      title: '住院病人结算单',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/live-toll/records-jiesu-list.vue'], resolve)
  },
  {
    path: `${basePath}/refund-management/`,
    name: `${basePath}/refund-management`,
    meta: {
      title: '退费审核',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace'
      }
    },
    component: resolve => require(['../views/page/live-toll/refund-management.vue'], resolve)
  }
]

var settleAccountsMetaNav = {
  title: '工作站',
  path: '/default/workplace',
  children: {
    title: '病区病人',
    path: `/default/${basePath}/area-patient-list`
  }
}
var settleAccountsBaseName = 'settle-accounts-tabs'
liveTollRoutes.push({
  path: `${basePath}/settle-accounts-tabs/:id`,
  name: `${basePath}/settle-accounts-tabs`,
  redirect: function (route) {
    return route.path + '/receipt'
  },
  meta: {
    title: '结算单详细记录',
    requiresAuth: true,
    nav: settleAccountsMetaNav
  },
  component: resolve => require(['../views/page/live-toll/settle-accounts-tabs.vue'], resolve),
  children: [
    {
      path: 'receipt',
      name: `${settleAccountsBaseName}-receipt`,
      meta: {
        title: '结算单详细记录-收据',
        requiresAuth: true,
        nav: settleAccountsMetaNav
      },
      component: resolve => require(['../views/page/live-toll/components/tab-settle-receipt.vue'], resolve)
    },
    {
      path: 'summary',
      name: `${settleAccountsBaseName}-summary`,
      meta: {
        title: '结算单详细记录-汇总',
        requiresAuth: true,
        nav: settleAccountsMetaNav
      },
      component: resolve => require(['../views/page/live-toll/components/tab-settle-summary.vue'], resolve)
    },
    {
      path: 'details',
      name: `${settleAccountsBaseName}-details`,
      meta: {
        title: '结算单详细记录-明细',
        requiresAuth: true,
        nav: settleAccountsMetaNav
      },
      component: resolve => require(['../views/page/live-toll/components/tab-settle-details.vue'], resolve)
    },
    {
      path: 'social-security-list',
      name: `${settleAccountsBaseName}-social-security-list`,
      meta: {
        title: '结算单详细记录-社保清单',
        requiresAuth: true,
        nav: settleAccountsMetaNav
      },
      component: resolve => require(['../views/page/live-toll/components/tab-settle-social-security-list.vue'], resolve)
    },
    {
      path: 'pre-amount',
      name: `${settleAccountsBaseName}-pre-amount`,
      meta: {
        title: '结算单详细记录-预收金',
        requiresAuth: true,
        nav: settleAccountsMetaNav
      },
      component: resolve => require(['../views/page/live-toll/components/tab-settle-pre-amount.vue'], resolve)
    },
    {
      path: 'refund-pre-amount',
      name: `${settleAccountsBaseName}-refund-pre-amount`,
      meta: {
        title: '结算单详细记录-退预收金',
        requiresAuth: true,
        nav: settleAccountsMetaNav
      },
      component: resolve => require(['../views/page/live-toll/components/tab-settle-refund-pre-amount.vue'], resolve)
    },
    {
      path: 'refund-list',
      name: `${settleAccountsBaseName}-refund-list`,
      meta: {
        title: '结算单详细记录-退费清单',
        requiresAuth: true,
        nav: settleAccountsMetaNav
      },
      component: resolve => require(['../views/page/live-toll/components/tab-settle-refund-list.vue'], resolve)
    }
  ]
})

export default liveTollRoutes
